import React, { useState } from 'react'
import { DialogProfileCatalog } from './DialogProfileCatalog'
import { initialState } from '../../models/catalog'

export const Crear = ({ handleUpdate, handleNew }) => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <button className='btn p-btn-primary' onClick={() => setOpen(true)} style={{ width: '150px' }}>
                <i className="bi bi-plus"></i> Crear servicio
            </button>

            {open && (
                <DialogProfileCatalog
                    open={open}
                    setOpen={setOpen}
                    initialState={initialState}
                    handleUpdate={handleUpdate}
                    handleNew={handleNew}
                />
            )}

        </>
    )

}
